import { Component, Host, h, State, Prop, Element, Listen } from '@stencil/core';
import getAxios from '../../../utils/get-axios';
import { $$$ } from '../../../utils/utils';
import Debounce from 'debounce-decorator';

declare let globals: any;

@Component({
  tag: 'lilu-search',
  styleUrl: 'lilu-search.scss',
  shadow: true,
})
export class LiluSearch {
  @Prop() ajaxUrl = '';
  @State() value = '';
  @State() category: any;
  @State() products: any;
  @State() productIndex: number = -1;
  @State() categoryIndex: number = -1;
  @State() isOpenAutocomplete: boolean;
  @Prop() dataSearchUrl: string;

  @Element() el: HTMLElement;

  selectedColumn: string = null;

  @Debounce(350)
  getSearchValue(searchValue) {
    getAxios.get(`${this.ajaxUrl}?term=${searchValue}`).then(res => {
      this.category = res.data.categories;
      this.products = res.data.products;
      this.resetSelectedItems();

      if (this.products?.length > 0 || this.category?.length > 0) {
        this.isOpenAutocomplete = true;
      } else {
        this.isOpenAutocomplete = false;
      }
    });
  }

  onSubmit() {
    const form = $$$('.search > form')[0];
    form.submit();
  }

  onFocus(_) {
    if (this.value.length > 1 && (this.products?.length > 0 || this.category?.length > 0)) {
      this.isOpenAutocomplete = true;
    }
  }

  onKeyDown(event) {
    if (event.key === 'ArrowRight') {
      if (this.productIndex >= 0 || this.categoryIndex >= 0) {
        event.preventDefault();
        if (this.products.length > 0) {
          this.selectedColumn = 'right';
          this.productIndex = 0;
          this.categoryIndex = -1;
        }
        return false;
      }
    }

    if (event.key === 'ArrowLeft') {
      if (this.productIndex >= 0 || this.categoryIndex >= 0) {
        event.preventDefault();
        if (this.category.length > 0) {
          this.selectedColumn = 'left';
          this.productIndex = -1;
          this.categoryIndex = 0;
        }
        return false;
      }
    }

    if (event.key === 'ArrowDown') {
      if (this.productIndex === -1 && this.categoryIndex === -1) {
        this.selectedColumn = 'right';
      }

      if (this.selectedColumn === 'right') {
        event.preventDefault();
        this.productIndex = (this.productIndex + 1) % this.products.length;
        return false;
      } else if (this.selectedColumn === 'left') {
        event.preventDefault();
        this.categoryIndex = (this.categoryIndex + 1) % this.category.length;
        return false;
      }
    }

    if (event.key === 'ArrowUp') {
      if (this.selectedColumn === 'right') {
        event.preventDefault();
        if (this.productIndex === 0) {
          this.resetSelectedItems();
        } else if (this.productIndex >= 0) {
          this.productIndex = (this.productIndex - 1) % this.products.length;
        }
        return false;
      } else if (this.selectedColumn === 'left') {
        event.preventDefault();
        if (this.categoryIndex === 0) {
          this.resetSelectedItems();
        } else if (this.categoryIndex >= 0) {
          this.categoryIndex = (this.categoryIndex - 1) % this.category.length;
          return false;
        }
      }
    }

    if (event.key === 'Enter') {
      if (this.selectedColumn === 'right') {
        event.preventDefault();
        window.open(window.location.protocol + '//' + window.location.host + this.products[this.productIndex]?.url, '_self');
      } else if (this.selectedColumn === 'left') {
        event.preventDefault();
        window.open(window.location.protocol + '//' + window.location.host + this.category[this.categoryIndex]?.url, '_self');
      }
    }

    if (event.key === 'Escape') {
      this.closeAutoComplete();
    }
  }

  onKeyUp(event) {
    if (this.value === event.target.value) {
      return;
    }

    this.value = event.target.value;
    if (this.value.length > 1) {
      this.getSearchValue(this.value);
    } else {
      this.closeAutoComplete();
    }
  }

  onInput(event) {
    if (this.value === event.target.value) {
      return;
    }

    this.value = event.target.value;
    if(this.value.length > 1) {
      this.getSearchValue(this.value);
    } else {
      this.closeAutoComplete();
    }
  }
  closeAutoComplete() {
    this.resetSelectedItems();
    this.isOpenAutocomplete = false;
  }

  resetSelectedItems() {
    this.productIndex = -1;
    this.categoryIndex = -1;
    this.selectedColumn = '';
  }

  deleteInputValue() {
    this.value = '';

    document.querySelector('lilu-header').shadowRoot.querySelector('lilu-search').shadowRoot.querySelector<HTMLInputElement>('form > input').focus();
    this.closeAutoComplete();
  }

  getFlag(item) {
    if (item.liluFlag !== null && item.liluFlag !== "") {
      return `<lilu-badge size="size-sm">${item.liluFlag}</lilu-badge>`;
    } else if(item.configurable) {
      return `<lilu-badge size="size-sm" color="gray"><lilu-icon size='size-10 lg-size-12' color="nero" type="icon-pen-01"></lilu-icon></lilu-badge>`;
    } else {
      return '';
    }
  }

  @Listen('click', { target: 'window' })
  clickOutsideOfComponent(event) {
    // Do nothing when component receives a click inide
    if (event.composedPath().includes(this.el)) {
      return;
    }

    this.closeAutoComplete();
  }

  geti18n(key) {
    const translations = globals?.translations;
    return (translations && translations[key]) || key;
  }

  render() {
    return (
      <Host>
        <div class="form search">
          <form action={this.dataSearchUrl} method="GET">
            <button class="search" type="submit">
              <lilu-icon color="nero" type="icon-search"></lilu-icon>
            </button>
            <input
              type="text"
              autocomplete="off"
              class="input__search"
              name="text"
              maxlength="100"
              onFocus={event => this.onFocus(event)}
              onKeyDown={event => this.onKeyDown(event)}
              onKeyUp={event => this.onKeyUp(event)}
              onInput={event => this.onInput(event)}
              value={this.value}
              placeholder={this.geti18n('search.placeholder')}
            />
            <div class={`delete ${this.value.length > 0 ? 'show' : ''}`} onClick={() => this.deleteInputValue()}>
              <lilu-icon color="nero" type="icon-closed-01"></lilu-icon>
            </div>
          </form>
        </div>
        <div class={`search__autocomplete ${this.isOpenAutocomplete ? 'show' : ''}`}>
          <div class="left">
            <h2 class={`title`}> {this.geti18n('search.categoriestitle')}</h2>
            <ul>
              {this.category?.map((item: any = {}, index) => (
                <li class={`category-item ${this.categoryIndex !== -1 && this.categoryIndex === index ? 'current' : ''}`}>
                  <a href={`${item.url}`}>
                    <div class="item">
                      <span>
                        {item.term} ({item.productsCount})
                      </span>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div class="right">
            <h2 class={`title`}> {this.geti18n('search.productstitle')}</h2>
            <ul>
              {this.products?.map((item: any = {}, index) => (
                <li class={`list-item ${this.productIndex !== -1 && this.productIndex === index ? 'current' : ''} `}>
                  <a href={`${item.url}`}>
                    <div class="item">
                      <div class="item-img">
                        <img loading="lazy" src={`${item.images[0].url}`} alt="alt" />
                      </div>
                      <div class="item-text">
                        <div class="item-title">{item.name}</div>
                        <lilu-price type={item.liluhitprice ? 'hit' : 'normal'} size="size-sm">{`${item.price.currencyIso} ${item.price.formattedValue}`}</lilu-price>
                      </div>
                      <div class="item-flag" innerHTML={`${this.getFlag(item)}`}></div>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
            <div class="text-right" onClick={() => this.onSubmit()}>
              {this.geti18n('search.showMore')} &#x3e;
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
